var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "course_wrap" }, [
    _c("div", { staticClass: "course_admin" }, [
      _c("header", [
        _c("div", { staticClass: "goback", on: { click: _vm.goBack } }, [
          _c("img", {
            attrs: {
              src: require("../../../../static/images/course/icon-3.png")
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("返回")])
        ]),
        _vm._v(" "),
        _c("i"),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$route.query.courseName))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabs" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.$store.state.activeName,
                callback: function($$v) {
                  _vm.$set(_vm.$store.state, "activeName", $$v)
                },
                expression: "$store.state.activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "教学班", name: "first" } },
                [
                  _vm.$store.state.activeName == "first"
                    ? _c("teachclass", { ref: "teachclass" })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "课程预览", name: "second" } },
                [
                  _vm.$store.state.activeName == "second"
                    ? _c("course-content")
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.productFlag == 1
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "课程考核", name: "third" } },
                    [
                      _vm.$store.state.activeName == "third"
                        ? _c("courseassessment", { ref: "courseassessment" })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.productFlag == 1
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "课程考试", name: "fourth" } },
                    [
                      _vm.$store.state.activeName == "fourth"
                        ? _c("coursetest")
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "讨论答疑", name: "fifth" } },
                [
                  _vm.$store.state.activeName == "fifth"
                    ? _c("discussanswer")
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "课程通知", name: "sixth" } },
                [
                  _vm.$store.state.activeName == "sixth"
                    ? _c("coursenotice", { ref: "coursenotice" })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a404b4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a404b4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TeachClass/courseAdmin.vue
// module id = null
// module chunks = 